import Splide from "@splidejs/splide";

export class SliderManager {
    constructor() {
        if (document.querySelector('.image-slider')) {
            this.initializeTestimonialSlider();
        }
    }

    initializeTestimonialSlider() {
        new Splide('.image-slider', {
            perPage: 4,
            perMove: 1,
            heightRatio: 0.25,
            gap: '30px',
            type: 'loop',
            arrows: true,
            mediaQuery: 'min',
            breakpoints: {
                1400: {
                    perPage: 4,
                    heightRatio: 0.25,
                },
                991: {
                    perPage: 3,
                    heightRatio: 0.25,
                },
                567: {
                    perPage: 2,
                    heightRatio: 0.5,
                },
                100: {
                    perPage: 1,
                    heightRatio: 1,
                }
            },
        }).mount();
    }

    
}
